import { api } from '@/lib/api';
import type { AcceptAgreementResponse, VendorAgreementsResponse } from './types';

export async function fetch_vendor_agreements(): Promise<VendorAgreementsResponse> {
  const res = await api.get<VendorAgreementsResponse>('/vendor/agreements');
  return res.data;
}

export async function accept_vendor_agreement(agreement_id: string): Promise<AcceptAgreementResponse> {
  const res = await api.post<AcceptAgreementResponse>(`/vendor/agreements/${agreement_id}/accept`);
  return res.data;
}
